<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { computed } from 'vue';

defineOptions({ inheritAttrs: false });

const props = withDefaults(
    defineProps<{
        className?: HTMLAttributes['class'];
        /** Unique prefix for SVG gradient ids (must be unique per instance on a page). */
        uid?: string;
    }>(),
    {
        uid: 'ct-logo',
    },
);

// Deterministic ids — avoid Vue useId() which can drift between SSR and client.
const outerGrad = computed(() => `${props.uid}-outer`);
const midGrad = computed(() => `${props.uid}-mid`);
const innerGrad = computed(() => `${props.uid}-inner`);
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="none"
        :class="className"
        v-bind="$attrs"
        aria-hidden="true"
    >
        <defs>
            <linearGradient :id="outerGrad" x1="1" y1="4" x2="31" y2="28" gradientUnits="userSpaceOnUse">
                <stop stop-color="#7C3AED" />
                <stop offset="0.5" stop-color="#C026D3" />
                <stop offset="1" stop-color="#F43F5E" />
            </linearGradient>
            <linearGradient :id="midGrad" x1="5" y1="7" x2="27" y2="25" gradientUnits="userSpaceOnUse">
                <stop stop-color="#2563EB" />
                <stop offset="0.5" stop-color="#06B6D4" />
                <stop offset="1" stop-color="#22D3EE" />
            </linearGradient>
            <linearGradient :id="innerGrad" x1="10" y1="11" x2="22" y2="21" gradientUnits="userSpaceOnUse">
                <stop stop-color="#10B981" />
                <stop offset="0.5" stop-color="#2DD4BF" />
                <stop offset="1" stop-color="#A3E635" />
            </linearGradient>
        </defs>

        <!-- Spaced rings — transparent gaps between circles -->
        <circle cx="16" cy="16" r="14.25" :stroke="`url(#${outerGrad})`" stroke-width="3.25" />
        <circle cx="16" cy="16" r="9" :stroke="`url(#${midGrad})`" stroke-width="3" />
        <circle cx="16" cy="16" r="4" :stroke="`url(#${innerGrad})`" stroke-width="2.75" />
    </svg>
</template>
